import React, { Component } from "react";
import {
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBRow,
    MDBCol,
    MDBIcon,
    toast,
    MDBTabPane,
    MDBTabContent,
    MDBNav,
    MDBNavItem,
    MDBNavLink,
    MDBSpinner,
    MDBInput,
    MDBTooltip,
} from "mdbreact";
import { withTranslation } from "react-i18next";
import axios from "../../../axios";
import OperatorSupportedLocalesTable from "../../../components/NetworkMgmt/Settings/Datatables/OperatorSupportedLocalesTable";
import OperatorAdministratorsTable from "../../../components/NetworkMgmt/Settings/Datatables/OperatorAdministratorsTableMUI";
import OperatorServicePlansTable from "../../../components/NetworkMgmt/Settings/Datatables/OperatorServicePlansTable";
import OperatorRadiusServerTable from "../../../components/NetworkMgmt/Settings/Datatables/OperatorRadiusServerTable";
import OperatorKeypoolsTable from "../../../components/NetworkMgmt/Settings/Datatables/OperatorKeypoolsTable";
import OperatorPMSProfilesTable from "../../../components/NetworkMgmt/Settings/Datatables/OperatorPMSProfilesTable";
import OperatorRuckusR1Table from "../../../components/NetworkMgmt/Settings/Datatables/OperatorRuckusR1Table";
import AddServicePlan from "../../../components/NetworkMgmt/Forms/AddServicePlan/AddServicePlan";
import ModifyServicePlan from "../../../components/NetworkMgmt/Forms/ModifyServicePlan/ModifyServicePlan";
import AddRadiusServer from "../../../components/NetworkMgmt/Forms/AddRadiusServer/AddRadiusServer";
import AddDomainAdministrator from "../../../components/NetworkMgmt/Forms/AddDomainAdministrator/AddDomainAdministrator";
import AddKeypool from "../../../components/NetworkMgmt/Forms/AddKeypool/AddKeypool";
import AddShoppingCart from "../../../components/NetworkMgmt/Forms/AddShoppingCart/AddShoppingCart";
import AddRealPage from "../../../components/NetworkMgmt/Forms/AddRealPage/AddRealPage";
import AddPMSProfile from "../../../components/NetworkMgmt/Forms/AddPMSProfile/AddPMSProfile";
import AddMetadataURL from "../../../components/NetworkMgmt/Forms/AddMetadataURL/AddMetadataURL";
import AddWebhook from "../../../components/NetworkMgmt/Forms/AddWebhook/AddWebhook";
import AddRuckusR1 from "../../../components/NetworkMgmt/Forms/AddRuckusR1/AddRuckusR1";
import ModifyRuckusR1 from "../../../components/NetworkMgmt/Forms/ModifyRuckusR1/ModifyRuckusR1";
import Transactions from "../../../components/NetworkMgmt/Transactions/Transactions";
import KeypoolInfo from "../../../components/NetworkMgmt/Settings/KeypoolInfo";
import CopyToClipboardButton from "../../utils/copyToClipboard"
import { DateInput } from "semantic-ui-calendar-react";
import {
    CountryDropdown,
    RegionDropdown,
} from "vault-react-country-region-selector";
import "react-phone-number-input/style.css";
import PhoneInput, {
    isPossiblePhoneNumber,
    isValidPhoneNumber,
} from "react-phone-number-input";
import _ from "lodash";
import countryInfo from "country-locale-map";
import getSymbolFromCurrency from "currency-symbol-map";
import JSONPretty from "react-json-pretty";
import LogViewer from "../../../components/NetworkMgmt/Logs/LogViewer";
import EditDomainAdministrator from "../../../components/NetworkMgmt/Forms/EditDomainAdministrator/EditDomainAdministrator";
class OperatorInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            operatorInfo: undefined,
            activeItem: "1",
            loading_info: false,
            modalAddServicePlan: false,
            modalAddPMSProfile: false,
            isModifyingPMSProfile: false,
            selectedPMSProfile: null,
            modify_operator: false,
            disabled:
                sessionStorage.getItem("customerSupport") > 0 ? true : false,
            toggleConfirmDeleteSSO: false,
            toggleConfirmDeletePMSProfile: false,
            selectedPMSProfileForDeletion: null,
            pmsProfilesList: undefined,
            loading_pms_profiles: false,
            delete_pms_profile: false,
            operatorLog: undefined,
            loading_logs: false,
            showEditModal: false,
            selectedAdministrator: null,
            administrators: [], // Your list of administrators,
            loading_ruckusR1Controllers: false,
            modalAddRuckusR1: false,
            modalModifyRuckusR1: false,
            modalDeleteRuckusR1: false,
            selectedRuckusR1Controller: null,
            controllerToDelete: null,
   dateStart: undefined,
   dateEnd: undefined,
        };
    }
    componentDidMount() {
        this.getOperatorInfo();
        this.getLogs({ preventDefault: () => {} });
        this.getPMSProfiles();
        this.getRuckusR1Devices();
        // this.getDisplayInfo();
    }
    getDisplayInfo = (defaultDisplayOptionID) => {
     let body = {
         AccessToken: sessionStorage.getItem("AccessToken"),
         IdToken: sessionStorage.getItem("IdToken"),
     };
     this.setState({
         loading_info: true,
         // operatorInfo: undefined,
     });
     axios
         .post("/operatorconsole/config/listDisplayOptions", body, {
             headers: {},
         })
         .then(
             (response) => {
                 this.setState({
                     allDisplayOptions: response.data.DisplayOptions,
                     allMetaOptions: response.data.metaOptions,
                 });
                 Object.keys(response.data.DisplayOptions).map(
                        (oneKey, i) => {
                            if (response.data.DisplayOptions[oneKey].DisplayOptionID === defaultDisplayOptionID) {
                                this.setState({
                                    defaultDisplayOptionName: response.data.DisplayOptions[oneKey].DisplayOptionName,
                                });
                                return true;
                            }
                        }
                    );
                    this.setState({ loading_info: false });
                },
                (error) => {
                    this.setState({ loading_info: false });
                }
            );
    };
    getOperatorInfo = () => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        this.setState({
            loading_info: true,
            operatorInfo: undefined,
            servicePlans: [],
        });
        axios
            .post(
                "/networkoperatorconsole/equipment/listOperatorDetails",
                body,
                {
                    headers: {},
                }
            )
            .then(
                (response) => {
                    this.setState({
                        operatorInfo: response.data,
                        domainAdminList: response.data["DomainAdministrators"],
                        siemAdminList: response.data["SIEMAdministrators"],
                        accountMgrList: response.data["AccountManagers"],
                        customerSupportList: response.data["CustomerSupport"],
                        servicePlans: response.data["ServicePlans"],
                        shoppingCart: response.data["ShoppingCart"],
                        defaultVenueConfig:
                            response.data["ServicePlanConfiguration"],
                        cognitoPoolId: response.data["SignOn"]["Cognito"]["CognitoPool"],
                        cognitoPoolDomain: response.data["SignOn"]["Cognito"]["CognitoPool_Domain"],
                        oktaMetadataURL:response.data["SignOn"]["Cognito"]["CognitoPool_IdentityProviders"]?.["SAML"]?.["okta"],
                        office365MetadataURL: response.data["SignOn"]["Cognito"]["CognitoPool_IdentityProviders"]?.["SAML"]?.["office365"],
                        webhookURL: response.data["WebhookURL"],
                        networkOperatorName:
                            response.data["NetworkOperatorName"],
                        address1: response.data["AddressLine1"],
                        address2: response.data["AddressLine2"],
                        city: response.data["City"],
                        region: response.data["State"],
                        country: response.data["Country.ISO3166A3"],
                        postalcode: response.data["PostalCode"],
                        email: response.data["EmailAddress"],
                        phoneNumber: response.data["PhoneNumber"],
                        domain: response.data["EmailDomain"],
                        allowOverlapping:
                            response.data["NetworkConfiguration"][
                                "allowOverlappingSubscriptionWiredUnit"
                            ],
                        allowCustomPSK:
                            response.data["NetworkConfiguration"]["CustomPSK"],
                        pinpointID:
                            response.data["Notifications"]["Pinpoint"][
                                "PinpointID"
                            ],
                        smsphoneNumber:
                            response.data["Notifications"]["SNS"][
                                "SMSConsolePhoneNumber"
                            ],
                        shoppingCartShortURL:
                            response.data["ShoppingCart"][
                                "ShoppingCartShortURL"
                            ],
                        currencySymbol: countryInfo.getCurrencyByAlpha3(
                            response.data["Country.ISO3166A3"]
                        ),
                        displayOptionID: response.data["DisplayOptionID"]
                    });
                    sessionStorage.setItem(
                        "showCustomPSK",
                        response.data.NetworkConfiguration[
                        "CustomPSK"
                        ]
                    );
                    this.setState({ loading_info: false });
                    this.getAdmins();
                    this.getGlobalKeypools();
                    this.getDisplayInfo(response.data["DisplayOptionID"])
                },
                (error) => {
                    this.setState({ loading_info: false });
                }
            );
    };
    
    getPMSProfiles = () => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
        };
        this.setState({
            loading_pms_profiles: true,
            pmsProfilesList: [],
        });
        axios
            .post("/operatorconsole/config/listPMSProfiles", body, {
                headers: {},
            })
            .then(
                (response) => {
                    this.setState({
                        pmsProfilesList: response.data.PMSProfiles,
                        supportedPMSTypes: response.data.SupportedPMSTypes,
                        loading_pms_profiles: false,
                    });
                },
                (error) => {
                    this.setState({ 
                        loading_pms_profiles: false,
                        pmsProfilesList: []
                    });
                }
            );
    };
    
    toggleCheckboxValueAllowOverlapping = () => {
        this.setState({ allowOverlapping: !this.state.allowOverlapping });
    };
    toggleCheckboxValueAllowCustomPSK = () => {
        this.setState({ allowCustomPSK: !this.state.allowCustomPSK });
    };
    changeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    changeHandlerPhone = (event) => {
        this.setState({ phoneNumber: event });
        var value = event
            ? isPossiblePhoneNumber(event)
                ? undefined
                : "Please provide a valid phone number"
            : "Phone number required";
        this.setState({ invalidPhone: value });
    };
    changeHandlerSMSPhone = (event) => {
        this.setState({ smsphoneNumber: event });
        var value = event
            ? isPossiblePhoneNumber(event)
                ? undefined
                : "Please provide a valid phone number"
            : "Phone number required";
        this.setState({ invalidPhone: value });
    };
    submitModifyOperator = (event) => {
        event.preventDefault();
        this.setState({ modify_operator: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            NetworkOperatorName: this.state.networkOperatorName,
            AddressLine1: this.state.address1,
            AddressLine2: this.state.address2,
            City: this.state.city,
            State: this.state.region,
            "Country.ISO3166A3": this.state.country,
            PostalCode: this.state.postalcode,
            EmailAddress: this.state.email,
            "PhoneNumber.E164": this.state.phoneNumber,
            EmailDomain: this.state.domain,
            allowOverlappingSubscriptionWiredUnit: this.state.allowOverlapping,
            "SMSConsolePhoneNumber.E164": this.state.smsphoneNumber,
            CustomPSK: this.state.allowCustomPSK
        };
        axios.post(
         "/networkoperatorconsole/equipment/configureNetworkOperator",
         body,
         { headers: {} }
     )
     .then((response) => {
      toast.success("Operator Info Modified!", {
          closeButton: false,
      });
      this.getOperatorInfo();
                    this.setState({ modify_operator: false });
  })
  .catch((error) => {
   toast.error("There was an error!", {
    closeButton: false,
});
this.setState({ modify_operator: false });
});
    };
    selectCountry(val) {
        this.setState({ country: val });
    }
    selectRegion(val) {
        this.setState({ region: val });
    }
    getLogs = (event) => {
        this.setState({ 
            operatorLog: undefined, 
            loading_logs: true 
        });
        event.preventDefault();
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            "MinViewWindowDateUTC.ISO8601": this.state.dateStart ? new Date(this.state.dateStart).toISOString() : undefined,
            "MaxViewWindowDateUTC.ISO8601": this.state.dateEnd ? new Date(this.state.dateEnd).toISOString() : undefined,
        };
        axios
            .post("/networkoperatorconsole/equipment/listOperatorLog", body, {
                headers: {},
            })
            .then((response) => {
                this.setState({
                    operatorLog: response.data.log,
                    loading_logs: false,
                });
            })
            .catch((error) => {
                this.setState({ 
                    error: true, 
                    loading_logs: false 
                });
            });
    };
    getAdmins = () => {
        this.setState({ staffArrayAll: undefined });
        let staffArrayAll = [];
        let staffArrayDomain = [];
        let staffArraySEIM = [];
        let staffArrayAccountMgr = [];
        let staffArrayCustomerSupport = [];
        for (let i = 0; i < this.state.domainAdminList.length; i++) {
            staffArrayDomain[i] = {
                [this.state.domainAdminList[i]]: "Domain Administrator",
            };
        }
        for (let j = 0; j < this.state.siemAdminList.length; j++) {
            staffArraySEIM[j] = {
                [this.state.siemAdminList[j]]: "SIEM Administrator",
            };
        }
        for (let j = 0; j < this.state.accountMgrList.length; j++) {
            staffArrayAccountMgr[j] = {
                [this.state.accountMgrList[j]]: "Account Manager",
            };
        }
        for (let j = 0; j < this.state.customerSupportList.length; j++) {
            staffArrayCustomerSupport[j] = {
                [this.state.customerSupportList[j]]: "Customer Support",
            };
        }
        staffArrayAll = staffArrayDomain.concat(
            staffArraySEIM,
            staffArrayAccountMgr,
            staffArrayCustomerSupport
        );
        this.setState({ staffArrayAll: [...staffArrayAll] });
    };
    toggleAddDomainAdministrator = () => {
        this.setState({
            modalAddDomainAdministrator:
                !this.state.modalAddDomainAdministrator,
        });
    };
    submitAddDomainAdministrators = (
        email,
        firstName,
        lastName,
        language,
        role
    ) => {
        this.setState({ add_domainadmin: true, staffArrayAll: undefined });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddress: email,
            GivenName: firstName,
            FamilyName: lastName,
            locale: language,
            Role: role,
        };
        axios
            .post("/networkoperatorconsole/staff/enableStaffAccess", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Added Staff!", {
                        closeButton: false,
                    });
                    this.toggleAddDomainAdministrator();
                    this.setState({ add_domainadmin: false });
                    this.getOperatorInfo();
                },
                (error) => {
                    toast.error("There was an error!", {
                        closeButton: false,
                    });
                    this.toggleAddDomainAdministrator();
                    this.setState({ add_domainadmin: false });
                }
            );
    };
    toggleConfirmDisable = (key) => {
        this.setState({
            toggleConfirm: true,
            modal: !this.state.modal,
            confirmEmail: key,
        });
    };
    toggleDisable = (email) => {
        this.setState({ staffArrayAll: undefined });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddress: email,
        };
        axios
            .post("/networkoperatorconsole/staff/disableStaffAccess", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Deleted Administrator", {
                        closeButton: false,
                    });
                    this.setState({
                        modal: !this.state.modal,
                    });
                    this.setState({ add_domainadmin: false });
                    this.getOperatorInfo();
                },
                (error) => {
                    toast.error(
                        error?.response?.data?.message || "There was an error!",
                        {
                            closeButton: false,
                        }
                    );
                    this.setState({
                        modal: !this.state.modal,
                    });
                    this.setState({ add_domainadmin: false });
                    // Restore the administrators list so the table re-renders
                    // instead of showing an endless spinner (NETWORKUI-725)
                    this.getOperatorInfo();
                }
            );
    };
    resendActivation = (email) => {
     let body;
        body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddress: email,
            UserTimeZone: new Date().getTimezoneOffset(),
        };
        axios
            .post("/subscriberconsole/initiateResetConsolePassword", body, {
                headers: {},
            })
            .then(
                (response) => {
                 toast.success(
                  response.data.message,
                  {
                      closeButton: false,
                  }
              );
                    this.getOperatorInfo();
                },
                (error) => {
                    toast.error(
                     error.response.data.message, 
                     {
                        closeButton: false,
                    }
                 );
                }
            );
    };
    toggleTab = (tab) => () => {
        if (this.state.activeItem !== tab) {
            this.setState({
                activeItem: tab,
            });
        }
    };
    toggleAddServicePlan = () => {
        this.setState({
            modalAddServicePlan: !this.state.modalAddServicePlan,
        });
    };
    toggleAddRuckusR1 = () => {
        this.setState({
            modalAddRuckusR1: !this.state.modalAddRuckusR1,
        });
    };
    toggleModifyRuckusR1 = () => {
        this.setState({
            modalModifyRuckusR1: !this.state.modalModifyRuckusR1,
        });
    };
    handleModifyRuckusR1 = (controller) => {
        this.setState({
            selectedRuckusR1Controller: controller,
            modalModifyRuckusR1: true,
        });
    };
    toggleDeleteRuckusR1 = () => {
        this.setState({
            modalDeleteRuckusR1: !this.state.modalDeleteRuckusR1,
        });
    };
    handleDeleteRuckusR1 = (controller) => {
        this.setState({
            controllerToDelete: controller,
            modalDeleteRuckusR1: true,
        });
    };
    confirmDeleteRuckusR1 = () => {
        if (!this.state.controllerToDelete) return;
        
        this.setState({ loading_ruckus: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            ControllerID: this.state.controllerToDelete.ControllerID,
            delete: true,
        };
        
        axios
            .post("/operatorconsole/config/configureRuckusR1Controller", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Deleted Ruckus R1 Controller!", {
                        closeButton: false,
                    });
                    this.toggleDeleteRuckusR1();
                    this.getRuckusR1Devices();
                    this.getGlobalKeypools();
                    this.setState({ 
                        loading_ruckus: false,
                        controllerToDelete: null,
                    });
                },
                (error) => {
                    toast.error(
                        error.response?.data?.message || "There was an error!",
                        {
                            closeButton: false,
                        }
                    );
                    this.setState({ loading_ruckus: false });
                }
            );
    };
    refreshRuckusR1Pools = (controller) => {
        if (!controller || !controller.ControllerID) {
            toast.error("Invalid controller data", {
                closeButton: false,
            });
            return;
        }
        
        this.setState({ loading_ruckus: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            ControllerID: controller.ControllerID,
            updatePools: true,
        };
        
        axios
            .post("/operatorconsole/config/configureRuckusR1Controller", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Refreshed DP-SK Pools for " + controller.ControllerName + "!", {
                        closeButton: false,
                    });
                    this.getRuckusR1Devices();
                    this.getGlobalKeypools();
                    this.setState({ loading_ruckus: false });
                },
                (error) => {
                    toast.error(
                        error.response?.data?.message || "There was an error refreshing pools!",
                        {
                            closeButton: false,
                        }
                    );
                    this.setState({ loading_ruckus: false });
                }
            );
    };
    submitAddRuckusR1 = (
        controllerName,
        url,
        tenantId,
        apiClientId,
        apiClientSecret,
        enableSync
    ) => {
        this.setState({ loading_ruckus: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            ControllerName: controllerName,
            URL: url,
            TenantID: tenantId,
            APIClientID: apiClientId,
            APIClientSecret: apiClientSecret,
            EnableSync: enableSync,
        };
        axios
            .post("/operatorconsole/config/addRuckusR1Controller", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Added Ruckus R1 Controller!", {
                        closeButton: false,
                    });
                    this.toggleAddRuckusR1();
                    this.getRuckusR1Devices();
                    this.getGlobalKeypools();
                    this.setState({ loading_ruckus: false });
                },
                (error) => {
                    toast.error(
                        error.response?.data?.message || "There was an error!",
                        {
                            closeButton: false,
                        }
                    );
                    this.setState({ loading_ruckus: false });
                }
            );
    };
    submitModifyRuckusR1 = (
        originalTenantId,
        controllerName,
        url,
        tenantId,
        apiClientId,
        apiClientSecret,
        enableSync,
        controllerID
    ) => {
        this.setState({ loading_ruckus: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            ControllerName: controllerName,
            URL: url,
            TenantID: tenantId,
            APIClientID: apiClientId,
            EnableSync: enableSync,
            ControllerID: controllerID,
        };
        
        // Only include secret if provided
        if (apiClientSecret && apiClientSecret !== "") {
            body.APIClientSecret = apiClientSecret;
        }
        
        axios
            .post("/operatorconsole/config/configureRuckusR1Controller", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Updated Ruckus R1 Controller!", {
                        closeButton: false,
                    });
                    this.toggleModifyRuckusR1();
                    this.getRuckusR1Devices();
                    this.setState({ loading_ruckus: false });
                },
                (error) => {
                    toast.error(
                        error.response?.data?.message || "There was an error!",
                        {
                            closeButton: false,
                        }
                    );
                    this.setState({ loading_ruckus: false });
                }
            );
    };
    submitAddServicePlan = (
        servicePlanName,
        servicePlanDescription,
        uploadKbps,
        downloadKbps,
        conDevices,
        sessionTimeout,
        maxRecurrance,
        maxTrialCycles,
        billingCycleHours,
        billingCyclePrice,
        billingCycleRecurrence,
        trialcycles,
        spimage,
        globallyavailable,
        externalServicePlanID,
        smsCode,
        unique_plan_id,
        typical_download_speed,
        typical_upload_speed,
        privacy_policy_url,
        network_management_policy_url,
        data_allowance_policy_url,
        bundle_discounts_url,
        customer_service_url,
        wirelessOnlyPlan
    ) => {
     console.log("selected")
        this.setState({ add_serviceplan: true });
        const firstCurrencyValue = JSON.parse(sessionStorage.getItem("currencyNames"))[0];
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            ServicePlanName: servicePlanName,
            ServicePlanDescription: servicePlanDescription,
            UploadKbps: uploadKbps,
            DownloadKbps: downloadKbps,
            ConcurrentDevices: conDevices,
            SessionTimeoutSecondsPerDevice: sessionTimeout,
            MaximumTrialCyclesPerSubscriberPerVenue: maxTrialCycles,
            MaximumFreeEnrollmentsPerSubscriberPerVenue: maxRecurrance,
            BillingCycleHours: billingCycleHours,
            ["BillingCyclePrice." + firstCurrencyValue]:
                billingCyclePrice === undefined ? 0 : billingCyclePrice * 100,
            BillingCycleRecurrence: billingCycleRecurrence,
            ServicePlanImageURL: spimage,
            GloballyAvailablePlan: globallyavailable,
            WirelessOnlyPlan: wirelessOnlyPlan || false,
            TrialCycles: trialcycles === undefined ? 0 : trialcycles,
            externalServicePlanID: externalServicePlanID,
            SMSCode: smsCode,
            FCCLabel: {
                PlanID: unique_plan_id,
                TypicalUploadKbps: typical_upload_speed,
                TypicalDownloadKbps: typical_download_speed,
                PrivacyPolicyURL: privacy_policy_url,
                NetworkMgmtPolicyURL: network_management_policy_url,
                DataPolicyURL: data_allowance_policy_url,
                BundleDiscountURL: bundle_discounts_url,
                SupportURL: customer_service_url,
            },
        };
        // console.log(body)
        axios
            .post("/networkoperatorconsole/equipment/addServicePlan", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Added Service Plan!", {
                        closeButton: false,
                    });
                    this.toggleAddServicePlan();
                    this.getOperatorInfo();
                    this.setState({ add_serviceplan: false });
                },
                (error) => {
                    toast.error("There was an error!", {
                        closeButton: false,
                    });
                    this.toggleAddServicePlan();
                    this.setState({ add_serviceplan: false });
                }
            );
    };
    toggleModifyServicePlan = () => {
        this.setState({
            modalModifyServicePlan: !this.state.modalModifyServicePlan,
        });
    };
    modifyServicePlan = (key, servicePlanID) => {
        this.setState({
            modalModifyServicePlan: !this.state.modalModifyServicePlan,
            servicePlanIDKey: key,
            servicePlanID: servicePlanID,
        });
    };
    submitModifyServicePlan = (
        servicePlanName,
        servicePlanID,
        servicePlanDescription,
        uploadKbps,
        downloadKbps,
        conDevices,
        sessionTimeout,
        maxRecurrance,
        // maxTrialCycles,
        billingCycleHours,
        billingCyclePrice,
        billingCycleRecurrence,
        trialCycles,
        spimage,
        globallyavailable,
        defaultForWiredUnits,
        defaultForLocalWireless,
        defaultForRoaming,
        externalServicePlanID,
        smsCode,
        wirelessOnlyPlan
    ) => {
        this.setState({ modify_serviceplan: true });
        const firstCurrencyValue = JSON.parse(sessionStorage.getItem("currencyNames"))[0];
        let updateServicePlan = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            ServicePlanID: servicePlanID,
            ServicePlanName: servicePlanName,
            ServicePlanDescription: servicePlanDescription,
            UploadKbps: uploadKbps,
            DownloadKbps: downloadKbps,
            ConcurrentDevices: conDevices,
            SessionTimeoutSecondsPerDevice: sessionTimeout,
            // MaximumTrialCyclesPerSubscriberPerVenue: maxTrialCycles,
            MaximumFreeEnrollmentsPerSubscriberPerVenue: maxRecurrance,
            BillingCycleHours: billingCycleHours,
            ["BillingCyclePrice." + firstCurrencyValue]: billingCyclePrice * 100,
            BillingCycleRecurrence: billingCycleRecurrence,
            ServicePlanImageURL: spimage,
            GloballyAvailablePlan: globallyavailable,
            WirelessOnlyPlan: wirelessOnlyPlan || false,
            TrialCycles: trialCycles,
            externalServicePlanID: externalServicePlanID,
            SMSCode: smsCode,
        };
        let updateNetworkOperator = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            ServicePlanConfiguration: {
                DefaultServicePlanID_GlobalWirelessPlusLocalWiredAccess:
                    defaultForWiredUnits === true ? servicePlanID : "",
                DefaultServicePlanID_LocalWirelessAccess:
                    defaultForLocalWireless === true ? servicePlanID : "",
                DefaultServicePlanID_Roaming:
                    defaultForRoaming === true ? servicePlanID : "",
            }
        };
        // console.log(updateServicePlan)
        Promise.all([
            axios.post(
                "/networkoperatorconsole/equipment/configureServicePlan",
                updateServicePlan,
                { headers: {} }
            ),
            axios.post(
                "/networkoperatorconsole/equipment/configureNetworkOperator",
                updateNetworkOperator,
                {
                    headers: {},
                }
            ),
        ])
            .then(async ([res1, res2]) => {
                toast.success("Updated Service Plan!", {
                    closeButton: false,
                });
                this.toggleModifyServicePlan();
                this.getOperatorInfo();
                this.setState({ modify_serviceplan: false });
            })
            .catch((error) => {
                toast.error(error.response.data.message, {
                    closeButton: false,
                });
                this.toggleModifyServicePlan();
                this.getOperatorInfo();
                this.setState({ modify_serviceplan: false });
            });
    };
    submitModifyServicePlanBroadbandLabel = (
        servicePlanID,
        unique_plan_id,
        typical_download_speed,
        typical_upload_speed,
        privacy_policy_url,
        network_management_policy_url,
        data_allowance_policy_url,
        bundle_discounts_url,
        customer_service_url
    ) => {
        this.setState({ modify_serviceplan: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            ServicePlanID: servicePlanID,
            FCCLabel: {
                PlanID: unique_plan_id,
                TypicalUploadKbps: typical_upload_speed,
                TypicalDownloadKbps: typical_download_speed,
                PrivacyPolicyURL: privacy_policy_url,
                NetworkMgmtPolicyURL: network_management_policy_url,
                DataPolicyURL: data_allowance_policy_url,
                BundleDiscountURL: bundle_discounts_url,
                SupportURL: customer_service_url,
            },
        };
        axios
            .post(
                "/networkoperatorconsole/equipment/configureServicePlan",
                body,
                {
                    headers: {},
                }
            )
            .then(
                (response) => {
                    toast.success(response.data.message, {
                        closeButton: false,
                    });
                    this.toggleModifyServicePlan();
                    this.getOperatorInfo();
                    this.setState({ modify_serviceplan: false });
                },
                (error) => {
                    this.toggleModifyServicePlan();
                    this.setState({ modify_serviceplan: false });
                }
            );
    };
    toggleAddRadiusServer = () => {
        this.setState({
            modalAddRadiusServer: !this.state.modalAddRadiusServer,
        });
    };
    submitAddRadiusServer = (ipAddy, authPort, acctPort) => {
        this.setState({ add_radius: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            RadiusServerIP: ipAddy,
            AuthenticationPort: authPort,
            AccountingPort: acctPort,
        };
        axios
            .post("/networkoperatorconsole/equipment/addRADIUSServer", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Added Radius Server!", {
                        closeButton: false,
                    });
                    this.toggleAddRadiusServer();
                    this.getOperatorInfo();
                    this.setState({ add_radius: false });
                },
                (error) => {
                    toast.error("There was an error!", {
                        closeButton: false,
                    });
                    this.toggleAddRadiusServer();
                    this.setState({ add_radius: false });
                }
            );
    };
    toggleConfirmRemoveRadiusServer = (key) => {
        this.setState({
            modalConfirmRemoveRadiusServer:
                !this.state.modalConfirmRemoveRadiusServer,
        });
    };
    removeRadiusServerConfirm = (key) => {
        this.toggleConfirmRemoveRadiusServer();
        this.setState({
            radiusIpAddy: key,
        });
    };
    removeRadiusServer = () => {
        this.setState({ add_radius: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            RadiusServerIP: this.state.radiusIpAddy,
        };
        axios
            .post(
                "/networkoperatorconsole/equipment/removeRADIUSServer",
                body,
                {
                    headers: {},
                }
            )
            .then(
                (response) => {
                    toast.success("Removed Radius Server!", {
                        closeButton: false,
                    });
                    this.getOperatorInfo();
                    this.toggleConfirmRemoveRadiusServer();
                },
                (error) => {
                    toast.error("There was an error!", {
                        closeButton: false,
                    });
                }
            );
    };
    toggleAddWifiController = () => {
        this.setState({
            modalAddWifiController: !this.state.modalAddWifiController,
        });
    };
    submitAddWifiController = (ipAddy) => {
        this.setState({ add_wifi: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            "NAS-IP-Address": ipAddy,
        };
        axios
            .post("/networkoperatorconsole/equipment/addWiFiController", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Added Wifi Controller!", {
                        closeButton: false,
                    });
                    this.toggleAddWifiController();
                    this.getOperatorInfo();
                    this.setState({ add_wifi: false });
                },
                (error) => {
                    toast.error("There was an error!", {
                        closeButton: false,
                    });
                    this.toggleAddWifiController();
                    this.setState({ add_wifi: false });
                }
            );
    };
    toggleConfirmRemoveWifiController = (key) => {
        this.setState({
            modalConfirmRemoveWifiController:
                !this.state.modalConfirmRemoveWifiController,
        });
    };
    removeWifiControllerConfirm = (key) => {
        this.toggleConfirmRemoveWifiController();
        this.setState({
            NASIpAddy: key,
        });
    };
    removeWifiController = () => {
        this.setState({ add_radius: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            "NAS-IP-Address": this.state.NASIpAddy,
        };
        axios
            .post(
                "/networkoperatorconsole/equipment/removeWiFiController",
                body,
                {
                    headers: {},
                }
            )
            .then(
                (response) => {
                    toast.success("Removed Wifi Controller!", {
                        closeButton: false,
                    });
                    this.getOperatorInfo();
                    this.toggleConfirmRemoveWifiController();
                },
                (error) => {
                    toast.error("There was an error!", {
                        closeButton: false,
                    });
                }
            );
    };
    getGlobalKeypools = () => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        this.setState({
            keypoolList: undefined,
        });
        axios
            .post("/networkoperatorconsole/keypools/listKeypools", body, {
                headers: {},
            })
            .then(
                (response) => {
                    var sortedKeys = _(response.data.myKeyPoolList)
                        .map(function (v, k) {
                            // insert the key into the object
                            return _.merge({}, v, { key: k });
                        })
                        .sortBy("DisplayOrder") // sort by name
                        .value();
                    this.setState({
                        keypoolList: sortedKeys,
                    });
                },
                (error) => {
                    toast.error("There was an error!", {
                        closeButton: false,
                    });
                }
            );
    };
    toggleAddKeypool = () => {
        this.setState({
            modalAddKeypool: !this.state.modalAddKeypool,
        });
    };
    submitAddKeypool = (ssid, venueID, scope, displayOrder) => {
        this.setState({ add_keypool: true });
        let body;
        if (scope === "global") {
            body = {
                AccessToken: sessionStorage.getItem("AccessToken"),
                IdToken: sessionStorage.getItem("IdToken"),
                SSID: ssid,
                Scope: scope,
                DisplayOrder: displayOrder,
            };
        } else {
            body = {
                AccessToken: sessionStorage.getItem("AccessToken"),
                IdToken: sessionStorage.getItem("IdToken"),
                SSID: ssid,
                VenueID: venueID,
                DisplayOrder: displayOrder,
            };
        }
        axios
            .post("/networkoperatorconsole/keypools/addKeypool", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Added Keypool!", {
                        closeButton: false,
                    });
                    this.toggleAddKeypool();
                    this.props.updateName(
                        this.props.venueName,
                        this.props.venueID
                    );
                    this.setState({ add_keypool: false });
                    this.getGlobalKeypools();
                },
                (error) => {
                    toast.error("There was an error!", {
                        closeButton: false,
                    });
                    this.toggleAddKeypool();
                    this.setState({ add_keypool: false });
                }
            );
    };
    removeUnitSSID = (ssid, unitIDInternal) => {
        this.setState({ loadingRemoveSSID: true, removingSSID: ssid });
        // Use keyPoolList to find all SSIDs assigned to this unit (matching Scope = unitIDInternal)
        // then remove the specified one and send the remaining list
        let existingSSIDs = [];
        if (this.props.keyPoolList) {
            Object.keys(this.props.keyPoolList).forEach(key => {
                const keypool = this.props.keyPoolList[key];
                if (keypool["Scope"] === unitIDInternal) {
                    existingSSIDs.push(keypool["ssid"]);
                }
            });
        }

        // Remove the SSID from the list
        const updatedSSIDs = existingSSIDs.filter(s => s !== ssid);

        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            UnitID_internal: unitIDInternal,
            NetworkConfiguration: {
                VenueUnitSSID: updatedSSIDs,
            },
        };

        axios
            .post("/operatorconsole/venues/configureVenueUnit", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success(response?.data?.message || "There was an error removing the SSID!", {
                        closeButton: false,
                    });
                    this.setState({ loadingRemoveSSID: false, removingSSID: null });
                    this.props.updateName(
                        this.props.venueName,
                        this.props.venueID
                    );
                    this.props.getVenueDetails(this.props.venueID);
                },
                (error) => {
                    toast.error(error?.response?.data?.message || "There was an error removing the SSID!", {
                        closeButton: false,
                    });
                    this.setState({ loadingRemoveSSID: false, removingSSID: null });
                }
            );
    };

    submitAddKeypool = (ssid, venueID, scope, displayOrder, keypoolRole, selectedUnit, existingUnitSSIDs = []) => {
        this.setState({ add_keypool: true });

        if (keypoolRole === "unit") {
            // Use the existing SSIDs passed directly from the form (already looked up)
            let updatedSSIDs = [...existingUnitSSIDs];

            // Add the new SSID if it's not already in the list
            if (!updatedSSIDs.includes(ssid)) {
                updatedSSIDs.push(ssid);
            }

            // Enforce a maximum of 4 Unit Level SSIDs per unit (NETWORKUI-722)
            if (updatedSSIDs.length > 4) {
                toast.error("A maximum of 4 Unit Level SSIDs are allowed per unit.", {
                    closeButton: false,
                });
                this.setState({ add_keypool: false });
                return;
            }

            let body = {
                AccessToken: sessionStorage.getItem("AccessToken"),
                UnitID_internal: selectedUnit,
                NetworkConfiguration: {
                    VenueUnitSSID: updatedSSIDs,
                },
            };

            axios
                .post("/operatorconsole/venues/configureVenueUnit", body, {
                    headers: {},
                })
                .then(
                    (response) => {
                        toast.success(response.data.message || "Unit keypool configured successfully!", {
                            closeButton: false,
                        });
                        this.toggleAddKeypool();
                        this.props.updateName(
                            this.props.venueName,
                            this.props.venueID
                        );
                        this.props.getVenueDetails(this.props.venueID);
                        this.setState({ add_keypool: false });
                    },
                    (error) => {
                        toast.error(error?.response?.data?.message || "There was an error!", {
                            closeButton: false,
                        });
                        this.toggleAddKeypool();
                        this.setState({ add_keypool: false });
                    }
                );
        } else {
            // Global or Venue keypool: use addKeypool API
            let body;
            if (scope === "global") {
                body = {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    IdToken: sessionStorage.getItem("IdToken"),
                    SSID: ssid,
                    Scope: scope,
                    DisplayOrder: displayOrder,
                };
            } else {
                body = {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    IdToken: sessionStorage.getItem("IdToken"),
                    SSID: ssid,
                    VenueID: this.props.venueID,
                    DisplayOrder: displayOrder,
                };
            }

            axios
                .post("/networkoperatorconsole/keypools/addKeypool", body, {
                    headers: {},
                })
                .then(
                    (response) => {
                        toast.success(response.data.message, {
                            closeButton: false,
                        });
                        this.toggleAddKeypool();
                        this.props.updateName(
                            this.props.venueName,
                            this.props.venueID
                        );
                        this.props.getVenueDetails(this.props.venueID);
                        this.setState({ add_keypool: false });
                    },
                    (error) => {
                        toast.error("There was an error!", {
                            closeButton: false,
                        });
                        this.toggleAddKeypool();
                        this.setState({ add_keypool: false });
                    }
                );
        }
    };
    toggleKeypool = (key) => {
        this.setState({
            modalViewKeypool: !this.state.modalViewKeypool,
            keyPoolID: key,
        });
    };
    toggleKeypoolInfo = () => {
        this.setState({
            modalViewKeypool: !this.state.modalViewKeypool,
        });
    };
    modifyVenueAddress = (
        address1,
        address2,
        phoneNumber,
        country,
        city,
        region,
        zipcode,
        sharedSecret
    ) => {
        if (address2 === undefined) {
            address2 = "";
        }
        this.setState({ loading: true });
        this.setState({ reloadVenueList: true });
        const data = {
            VenueID: sessionStorage.getItem("venueID"),
            AddressLine1: address1,
            AddressLine2: address2,
            City: city,
            State: region,
            PostalCode: zipcode,
            "Country.ISO3166A3": country,
            PhoneNumber: phoneNumber,
            SharedSecret: sharedSecret,
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        axios
            .post("/networkoperatorconsole/venues/updateVenueAddress", data, {
                headers: {},
            })
            .then(
                (response) => {
                    this.props.updateName(
                        sessionStorage.getItem("venueName"),
                        sessionStorage.getItem("venueID")
                    );
                    toast.success("Updated Venue Address!", {
                        closeButton: false,
                    });
                    this.setState({ loading: false });
                    this.setState({ reloadVenueList: false });
                },
                (error) => {
                    toast.error("There was an error", {
                        closeButton: false,
                    });
                    this.setState({ loading: false });
                    this.setState({ reloadVenueList: false });
                }
            );
    };
    toggle = () => {
        this.setState({
            modal: !this.state.modal,
        });
    };
    toggleAddShoppingCart = () => {
        this.setState({
            modalAddShoppingCart: !this.state.modalAddShoppingCart,
        });
    };
    submitAddShoppingCart = (
        enabled,
        publishableKey,
        secretKey,
        signingSecret,
        refund,
        shoppingCartShortURL
    ) => {
        this.setState({ add_shopping_cart: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            enableShoppingCart: enabled,
            StripePublishableKey: publishableKey,
            Stripe_Secret_key: secretKey,
            Stripe_Webhook_signingsecret: signingSecret,
            Stripe_allowrefund: refund,
            ShoppingCartShortURL: shoppingCartShortURL,
        };
        axios
            .post(
                "/networkoperatorconsole/equipment/configureNetworkOperator",
                body,
                {
                    headers: {},
                }
            )
            .then(
                (response) => {
                    toast.success("Updated Shopping Cart!", {
                        closeButton: false,
                    });
                    sessionStorage.setItem("cartEnabledGlobally", enabled);
                    this.toggleAddShoppingCart();
                    this.getOperatorInfo();
                    this.setState({ add_shopping_cart: false });
                },
                (error) => {
                    toast.error("There was an error!", {
                        closeButton: false,
                    });
                    this.toggleAddShoppingCart();
                    this.setState({ add_shopping_cart: false });
                }
            );
    };
    toggleAddPMSProfile = () => {
        this.setState({
            modalAddPMSProfile: !this.state.modalAddPMSProfile,
            isModifyingPMSProfile: false,
            selectedPMSProfile: null,
        });
    };
    submitAddPMSProfile = (profileData) => {
        this.setState({ add_pms_profile: true });
        
        // Build request body based on PMS type
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            ProfileName: profileData.profileName,
            Type: profileData.type,
        };
        
        // Add type-specific fields
        if (profileData.type === "RealPage") {
            body.RealPageURL = profileData.realPageURL;
            body.RealPageAPIKey = profileData.realPageAPIKey;
            body.RealPagePMCId = profileData.realPagePMCId;
        } else if (profileData.type === "Entrata") {
            body.EntrataSubdomain = profileData.entrataSubdomain;
            body.EntrataAPIKey = profileData.entrataAPIKey;
        }
        
        // Add common fields
        body.enableSync = profileData.enableSync || false;
        
        // Add profile ID for updates
        if (this.state.isModifyingPMSProfile && this.state.selectedPMSProfile) {
            body.ProfileID = this.state.selectedPMSProfile.ProfileID;
        }
        
        // Determine the endpoint based on whether we're adding or modifying
        const endpoint = this.state.isModifyingPMSProfile 
            ? "/operatorconsole/config/configurePMSProfile" 
            : "/operatorconsole/config/addPMSProfile";
        
        axios
            .post(endpoint, body, {
                headers: {},
            })
            .then(
                (response) => {
                    const action = this.state.isModifyingPMSProfile ? "Updated" : "Added";
                    let successMessage = `${action} PMS Profile!`;
                    
                    // Check for specific success messages from the response
                    if (response.data && response.data.message) {
                        successMessage = response.data.message;
                    }
                    
                    toast.success(successMessage, {
                        closeButton: false,
                    });
                    this.toggleAddPMSProfile();
                    this.getOperatorInfo();
                    this.getPMSProfiles();
                    this.setState({ add_pms_profile: false });
                },
                (error) => {
                    const action = this.state.isModifyingPMSProfile ? "updating" : "adding";
                    let errorMessage = `There was an error ${action} the PMS Profile!`;
                    
                    // Check for specific error messages from the response
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    
                    toast.error(errorMessage, {
                        closeButton: false,
                    });
                    this.toggleAddPMSProfile();
                    this.setState({ add_pms_profile: false });
                }
            );
    };

    // PMS Profile Management Methods
    modifyPMSProfile = (profile) => {
        this.setState({
            selectedPMSProfile: profile,
            isModifyingPMSProfile: true,
            modalAddPMSProfile: true,
        });
    };

    deletePMSProfile = (profile) => {
        // Show confirmation dialog
        this.setState({
            selectedPMSProfileForDeletion: profile,
            toggleConfirmDeletePMSProfile: true,
        });
    };

    toggleConfirmDeletePMSProfile = () => {
        this.setState({
            toggleConfirmDeletePMSProfile: !this.state.toggleConfirmDeletePMSProfile,
        });
    };

    confirmDeletePMSProfile = () => {
        const profile = this.state.selectedPMSProfileForDeletion;
        if (profile) {
            this.setState({ delete_pms_profile: true });
            let body = {
                AccessToken: sessionStorage.getItem("AccessToken"),
                IdToken: sessionStorage.getItem("IdToken"),
                ProfileID: profile.ProfileID,
                delete: true
            };
            
            axios
                .post("/operatorconsole/config/configurePMSProfile", body, {
                    headers: {},
                })
                .then(
                    (response) => {
                        let successMessage = `Profile ${profile.ProfileName} deleted successfully!`;
                        
                        // Check for specific success messages from the response
                        if (response.data && response.data.message) {
                            successMessage = response.data.message;
                        }
                        
                        toast.success(successMessage, {
                            closeButton: false,
                        });
                        this.setState({
                            toggleConfirmDeletePMSProfile: false,
                            selectedPMSProfileForDeletion: null,
                        });
                        this.setState({ delete_pms_profile: false });
                        this.getPMSProfiles();
                    },
                    (error) => {
                        // Extract the error message from the server response
                        const errorMessage = error.response?.data?.message || "There was an error deleting the PMS profile!";
                        
                        toast.error(errorMessage, {
                            closeButton: false,
                        });
                        this.setState({
                            toggleConfirmDeletePMSProfile: false,
                            selectedPMSProfileForDeletion: null,
                        });
                        this.setState({ delete_pms_profile: false });
                    }
                );
        } else {
            this.setState({
                toggleConfirmDeletePMSProfile: false,
                selectedPMSProfileForDeletion: null,
            });
        }
    };

    toggleAddWebhook = () => {
        this.setState({
            modalAddWebhook: !this.state.modalAddWebhook,
        });
    };
    submitAddWebhook = (webhookurl) => {
        this.setState({ add_webhook: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            WebhookURL: webhookurl,
        };
        axios
            .post(
                "/networkoperatorconsole/equipment/configureNetworkOperator",
                body,
                {
                    headers: {},
                }
            )
            .then(
                (response) => {
                    toast.success("Added Webhook URL!", {
                        closeButton: false,
                    });
                    this.toggleAddWebhook();
                    this.getOperatorInfo();
                    this.setState({ add_webhook: false });
                },
                (error) => {
                    toast.error("There was an error!", {
                        closeButton: false,
                    });
                    this.toggleAddWebhook();
                    this.setState({ add_webhook: false });
                }
            );
    };
    toggleAddMetadataURLs = () => {
        this.setState({
            modalAddMetadataURLs: !this.state.modalAddMetadataURLs,
        });
    };
    toggleConfirmDeleteSSO = () => {
        this.setState({
            toggleConfirmDeleteSSO: !this.state.toggleConfirmDeleteSSO,
        });
    };
    confirmDeleteSSO = () => {
        this.deleteMetadataURLs();
        this.toggleConfirmDeleteSSO();
    };
    deleteMetadataURLs = () => {
        this.setState({ loading_info: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            Okta_MetadataURL: " ",
            Office365_MetadataURL: " ",
        };
        axios
            .post("/networkoperatorconsole/equipment/configureNetworkOperator", body, {
                headers: {},
            })
            .then(
                (response) => {
                    let successMessage = "Deleted Metadata URL(s)!";
                    if (response.data && response.data.message) {
                        successMessage = response.data.message;
                    }
                    toast.success(successMessage, {
                        closeButton: false,
                    });
                    this.getOperatorInfo();
                },
                (error) => {
                    this.setState({ loading_info: false });
                    let errorMessage = "There was an error!";
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    toast.error(errorMessage, {
                        closeButton: false,
                    });
                }
            );
    };
    submitAddMetadataURLs = (oktaMetadataURL, office365MetadataURL) => {
        this.setState({ addMetadataURLs: true });
        this.setState({ loading_info: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            Okta_MetadataURL: oktaMetadataURL,
            Office365_MetadataURL: office365MetadataURL,
        };
        axios
            .post("/networkoperatorconsole/equipment/configureNetworkOperator", body, {
                headers: {},
            })
            .then(
                (response) => {
                    this.setState({ loading_info: false });
                    let successMessage = "Updated Metadata URL!";
                    if (response.data && response.data.message) {
                        successMessage = response.data.message;
                    }
                    toast.success(successMessage, {
                        closeButton: false,
                    });
                    this.toggleAddMetadataURLs();
                    this.getOperatorInfo();
                    this.setState({ addMetadataURLs: false });
                },
                (error) => {
                    console.log("error", error);
                    this.setState({ loading_info: false });                    
                    let errorMessage = "There was an error!";
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    toast.error(errorMessage, {
                        closeButton: false,
                    });
                    this.toggleAddMetadataURLs();
                    this.setState({ addMetadataURLs: false });
                }
            );
    };
    toggleEditDomainAdministrator = (administrator = null) => {
        this.setState({
            showEditModal: !this.state.showEditModal,
            selectedAdministrator: administrator
        });
    };
    handleRoleUpdated = (administratorId, newRole) => {
        // Update the administrator list with the new role
        this.setState(prevState => ({
            administrators: prevState.administrators.map(admin =>
                admin.id === administratorId
                    ? { ...admin, role: newRole }
                    : admin
            )
        }));
    };
    loadAdministratorsData = () => {
        // Clear existing administrators data to show loading state
        this.setState({ staffArrayAll: undefined });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
        };
        axios
            .post("/networkoperatorconsole/equipment/listOperatorDetails", body, {
                headers: {},
            })
            .then((response) => {
                // Update the administrator lists from the fresh data
                this.setState({
                    domainAdminList: response.data["DomainAdministrators"],
                    siemAdminList: response.data["SIEMAdministrators"],
                    accountMgrList: response.data["AccountManagers"],
                    customerSupportList: response.data["CustomerSupport"],
                });
                // Rebuild the combined administrators array
                this.getAdmins();
            })
            .catch((error) => {
                console.error("Error loading administrators data:", error);
                this.setState({ error: true });
            });
    };
    handleChange = (event, { name, value }) => {
  if (this.state.hasOwnProperty(name)) {
   // Enhanced date validation for MM/DD/YYYY format
   if (name === 'dateStart' || name === 'dateEnd') {
    // Allow empty values for clearing
    if (!value || value === '') {
   this.setState({ [name]: value });
     return;
    }
    // Validate MM/DD/YYYY format with regex
    const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    // Only allow valid MM/DD/YYYY format
    if (dateRegex.test(value)) {
     // Additional validation: check if it's a valid date
     const [month, day, year] = value.split('/').map(Number);
     const date = new Date(year, month - 1, day);
     // Verify the date components match (handles invalid dates like 02/30/2024)
     if (date.getFullYear() === year && 
         date.getMonth() === month - 1 && 
         date.getDate() === day) {
      this.setState({ [name]: value });
     }
     // If invalid date components, don't update state
    }
    // If format doesn't match MM/DD/YYYY, don't update state
   } else {
    this.setState({ [name]: value });
   }
  }
 };
 getRuckusR1Devices = () => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        this.setState({
            radiusR1Devices: undefined,
            loading_ruckusR1Controllers: true,
        });
        axios
            .post("/operatorconsole/config/listRuckusR1Controllers", body, {
                headers: {},
            })
            .then(
                (response) => {
                    this.setState({
                        ruckusR1Controllers: response.data.RuckusR1Controllers,
                        loading_ruckusR1Controllers: false,
                    });
                },
                (error) => {
                    toast.error("There was an error!", {
                        closeButton: false,
                        loading_ruckusR1Controllers: false,
                    });
                }
            );
    }
    render() {
        const { t } = this.props;
        const FORMAT = "MM/dd/yyyy";
         const tomorrow = new Date(
   new Date().setDate(new Date().getDate() + 1)
  ).toISOString();
        return (
            <>
                {this.state.toggleConfirm ? (
                    <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
                        <MDBModalHeader toggle={this.toggle}>
                            Confirm Disable
                        </MDBModalHeader>
                        <MDBModalBody>
                            <p>Email: {this.state.confirmEmail}</p>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn
                                color="primary"
                                onClick={() =>
                                    this.toggleDisable(this.state.confirmEmail)
                                }
                            >
                                Confirm
                            </MDBBtn>
                            <MDBBtn color="primary" onClick={this.toggle}>
                                Close
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>
                ) : null}
                <MDBModal
                    isOpen={this.state.modalAddDomainAdministrator}
                    toggle={this.toggle}
                    size="lg"
                    className="form"
                    centered
                >
                    <AddDomainAdministrator
                        submitAddDomainAdministrators={
                            this.submitAddDomainAdministrators
                        }
                        toggleAddDomainAdministrator={
                            this.toggleAddDomainAdministrator
                        }
                        add_domainadmin={this.state.add_domainadmin}
                        loading={this.state.loading}
                        updateName={this.props.updateName}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalAddRadiusServer}
                    toggle={this.toggle}
                    size="lg"
                    className="form"
                    centered
                >
                    <AddRadiusServer
                        toggleAddRadiusServer={this.toggleAddRadiusServer}
                        submitAddRadiusServer={this.submitAddRadiusServer}
                        add_radius={this.state.add_serviceplan}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalAddServicePlan}
                    toggle={this.toggle}
                    size="fluid"
                    className="form"
                    centered
                >
                    <AddServicePlan
                        toggleAddServicePlan={this.toggleAddServicePlan}
                        submitAddServicePlan={this.submitAddServicePlan}
                        add_serviceplan={this.state.add_serviceplan}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalModifyServicePlan}
                    toggle={this.toggle}
                    size="fluid"
                    className="form"
                    centered
                >
                    <ModifyServicePlan
                        toggleModifyServicePlan={this.toggleModifyServicePlan}
                        submitModifyServicePlan={this.submitModifyServicePlan}
                        submitModifyServicePlanBroadbandLabel={
                            this.submitModifyServicePlanBroadbandLabel
                        }
                        modify_serviceplan={this.state.modify_serviceplan}
                        servicePlanIDKey={this.state.servicePlanIDKey}
                        servicePlanID={this.state.servicePlanID}
                        servicePlans={this.state.servicePlans}
                        defaultVenueConfig={this.state.defaultVenueConfig}
                        currencyName={this.state.currencyName}
                        refreshServicePlans={this.getOperatorInfo}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalConfirmRemoveRadiusServer}
                    toggle={this.toggleConfirmRemoveRadiusServer}
                >
                    <MDBModalHeader
                        toggle={this.toggleConfirmRemoveRadiusServer}
                    >
                        Confirm Remove Radius Server
                    </MDBModalHeader>
                    <MDBModalBody>
                        <p>IP Address: {this.state.radiusIpAddy}</p>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn
                            color="primary"
                            onClick={this.removeRadiusServer}
                        >
                            Confirm
                        </MDBBtn>
                        <MDBBtn
                            color="primary"
                            onClick={this.toggleConfirmRemoveRadiusServer}
                        >
                            Close
                        </MDBBtn>
                    </MDBModalFooter>
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalConfirmRemoveWifiController}
                    toggle={this.toggleConfirmRemoveWifiController}
                >
                    <MDBModalHeader
                        toggle={this.toggleConfirmRemoveWifiController}
                    >
                        Confirm Remove Wifi Controller
                    </MDBModalHeader>
                    <MDBModalBody>
                        <p>IP Address: {this.state.NASIpAddy}</p>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn
                            color="primary"
                            onClick={this.removeWifiController}
                        >
                            Confirm
                        </MDBBtn>
                        <MDBBtn
                            color="primary"
                            onClick={this.toggleConfirmRemoveWifiController}
                        >
                            Close
                        </MDBBtn>
                    </MDBModalFooter>
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalViewKeypool}
                    toggle={this.toggleKeypoolInfo}
                    size="lg"
                    className="form"
                    centered
                >
                    <KeypoolInfo
                        keypoolInfo={this.state.keypoolList}
                        toggleKeypoolInfo={this.toggleKeypoolInfo}
                        keyPoolID={this.state.keyPoolID}
                        modalViewKeypoolInfo={this.state.modalViewKeypoolInfo}
                        handleSelectChangeVenueFromList={
                            this.props.handleSelectChangeVenueFromList
                        }
                        getVenueDetails={this.props.getVenueDetails}
                        getVenues={this.props.getVenues}
                        attributeForm={this.props.attributeForm}
                        venueInfo={this.props.venueInfo}
                        unitsArrayAll={this.props.unitsArrayAll}
                        keyPoolList={this.props.keyPoolList}
                        servicePlans={this.props.servicePlans}
                        staffArrayAll={this.props.staffArrayAll}
                        venueEquipList={this.props.venueEquipList}
                        updateName={this.props.updateName}
                        sharedSecret={this.props.sharedSecret}
                        modifyVenueAddress={this.modifyVenueAddress}
                        getOperatorInfo={this.getOperatorInfo}
                        getGlobalKeypools={this.getGlobalKeypools}
                        venueID={this.props.venueID}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalAddKeypool}
                    toggle={this.toggle}
                    size="lg"
                    className="form"
                    centered
                >
                    <AddKeypool
                        toggleAddKeypool={this.toggleAddKeypool}
                        submitAddKeypool={this.submitAddKeypool}
                        add_keypool={this.state.add_keypool}
                        globalKey={true}
                        attributeForm={this.props.attributeForm}
                        venueID={this.props.venueID}
                        keyPoolList={this.props.keyPoolList}
                        Units-Building-Floor-List-Subscribers={this.props.venueInfo?.["Units-Building-Floor-List-Subscribers"]}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalAddShoppingCart}
                    toggle={this.toggleAddShoppingCart}
                    size="lg"
                    className="form"
                    centered
                >
                    <AddShoppingCart
                        toggleAddShoppingCart={this.toggleAddShoppingCart}
                        submitAddShoppingCart={this.submitAddShoppingCart}
                        add_shopping_cart={this.state.add_shopping_cart}
                        shoppingCart={this.state.shoppingCart}
                        shoppingCartShortURL={this.state.shoppingCartShortURL}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalAddPMSProfile}
                    toggle={this.toggleAddPMSProfile}
                    size="lg"
                    className="form"
                    centered
                >
                    <AddPMSProfile
                        toggleAddPMSProfile={this.toggleAddPMSProfile}
                        submitAddPMSProfile={this.submitAddPMSProfile}
                        add_pms_profile={this.state.add_pms_profile}
                        realPage={this.state.realPage}
                        isModifying={this.state.isModifyingPMSProfile}
                        selectedProfile={this.state.selectedPMSProfile}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalAddWebhook}
                    toggle={this.toggleAddWebhook}
                    size="lg"
                    className="form"
                    centered
                >
                    <AddWebhook
                        toggleAddWebhook={this.toggleAddWebhook}
                        submitAddWebhook={this.submitAddWebhook}
                        add_webhook={this.state.add_webhook}
                        webhookURL={this.state.webhookURL}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalAddMetadataURLs}
                    toggle={this.toggleAddMetadataURLs}
                    size="lg"
                    className="form"
                    centered
                >
                    <AddMetadataURL
                        toggleAddMetadataURLs={this.toggleAddMetadataURLs}
                        submitAddMetadataURLs={this.submitAddMetadataURLs}
                        addMetadataURLs={this.state.addMetadataURLs}
                        oktaMetadataURL={this.state.oktaMetadataURL}
                        office365MetadataURL={this.state.office365MetadataURL}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.toggleConfirmDeleteSSO}
                    toggle={this.toggleConfirmDeleteSSO}
                >
                    <MDBModalHeader
                        toggle={this.toggleConfirmDeleteSSO}
                    >
                        Confirm Delete Metadata URLs
                    </MDBModalHeader>
                    <MDBModalBody>
                        <p>Are you sure you want to delete the SSO metadata URLs?</p>
                        {this.state.oktaMetadataURL && (
                            <p><strong>Okta Metadata URL:</strong> {this.state.oktaMetadataURL}</p>
                        )}
                        {this.state.office365MetadataURL && (
                            <p><strong>Office365 Metadata URL:</strong> {this.state.office365MetadataURL}</p>
                        )}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn
                            color="danger"
                            onClick={this.confirmDeleteSSO}
                        >
                            Confirm
                        </MDBBtn>
                        <MDBBtn
                            color="primary"
                            onClick={this.toggleConfirmDeleteSSO}
                        >
                            Cancel
                        </MDBBtn>
                    </MDBModalFooter>
                </MDBModal>
                {this.state.loading_info === true ? (
                    <div 
                        id="operator-loading-modal"
                        className="overlay overlayIsInitialLoading"
                        style={{ 
                            position: 'fixed', 
                            top: 0, 
                            left: 0, 
                            width: '100vw', 
                            height: '100vh', 
                            backgroundColor: 'rgba(0, 0, 0, 0.8)', 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            zIndex: 999999999,
                            pointerEvents: 'auto'
                        }}
                    >
                        <div style={{ 
                            backgroundColor: 'white', 
                            padding: '30px', 
                            borderRadius: '12px', 
                            textAlign: 'center',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
                            maxWidth: '400px',
                            margin: '20px',
                            border: "3px solid var(--primary-color, #007bff)"
                        }}>
                            <div className="spinner-border spinner-border-lg text-primary mb-3" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                            <h5 className="mb-2 text-primary" style={{ color: "var(--primary-color, #007bff)" }}>Loading operator information...</h5>
                            <p className="mb-0 text-muted">Please wait while we fetch the operator details</p>
                        </div>
                    </div>
                ) : (
                    ""
                )}
                <MDBModalHeader toggle={this.props.toggleOperatorInfo}>
                    <h4>Operator Information</h4>
                    {this.state.activeItem === "1" ? (
                        <p>{t("addnewresident.required")}</p>
                    ) : (
                        ""
                    )}
                </MDBModalHeader>
                <MDBModalBody>
                    <MDBNav className="nav-tabs">
                        <MDBNavItem>
                            <MDBNavLink
                                link
                                to="#"
                                active={this.state.activeItem === "1"}
                                onClick={this.toggleTab("1")}
                                role="tab"
                            >
                                <MDBIcon icon="user" /> Profile
                            </MDBNavLink>
                        </MDBNavItem>
                        <MDBNavItem>
                            <MDBNavLink
                                link
                                to="#"
                                active={this.state.activeItem === "2"}
                                onClick={this.toggleTab("2")}
                                role="tab"
                            >
                                <MDBIcon icon="user-shield" /> Administrators
                            </MDBNavLink>
                        </MDBNavItem>
                        <MDBNavItem>
                            <MDBNavLink
                                link
                                to="#"
                                active={this.state.activeItem === "3"}
                                onClick={this.toggleTab("3")}
                                role="tab"
                            >
                                <MDBIcon icon="signal" /> Service Plans
                            </MDBNavLink>
                        </MDBNavItem>
                        <MDBNavItem>
                            <MDBNavLink
                                link
                                to="#"
                                active={this.state.activeItem === "4"}
                                onClick={this.toggleTab("4")}
                                role="tab"
                            >
                                <MDBIcon icon="server" /> Radius Servers
                            </MDBNavLink>
                        </MDBNavItem>
                        <MDBNavItem>
                            <MDBNavLink
                                link
                                to="#"
                                active={this.state.activeItem === "6"}
                                onClick={this.toggleTab("6")}
                                role="tab"
                            >
                                <MDBIcon icon="key" /> Keypools
                            </MDBNavLink>
                        </MDBNavItem>
                        <MDBNavItem>
                            <MDBNavLink
                                link
                                to="#"
                                active={this.state.activeItem === "7"}
                                onClick={this.toggleTab("7")}
                                role="tab"
                            >
                                <MDBIcon icon="shopping-cart" /> Shopping Cart
                            </MDBNavLink>
                        </MDBNavItem>
                        <MDBNavItem>
                            <MDBNavLink
                                link
                                to="#"
                                active={this.state.activeItem === "8"}
                                onClick={this.toggleTab("8")}
                                role="tab"
                            >
                                <MDBIcon icon="home" /> PMS Profiles
                            </MDBNavLink>
                        </MDBNavItem>
                        <MDBNavItem>
                            <MDBNavLink
                                link
                                to="#"
                                active={this.state.activeItem === "9"}
                                onClick={this.toggleTab("9")}
                                role="tab"
                            >
                                <MDBIcon icon="globe" /> Webhook
                            </MDBNavLink>
                        </MDBNavItem>
                        <MDBNavItem>
                            <MDBNavLink
                                link
                                to="#"
                                active={this.state.activeItem === "10"}
                                onClick={this.toggleTab("10")}
                                role="tab"
                            >
                                <MDBIcon icon="clipboard-list" /> Logs
                            </MDBNavLink>
                        </MDBNavItem>
                        <MDBNavItem>
                            <MDBNavLink
                                link
                                to="#"
                                active={this.state.activeItem === "11"}
                                onClick={this.toggleTab("11")}
                                role="tab"
                            >
                                <MDBIcon icon="handshake" /> SSO
                            </MDBNavLink>
                        </MDBNavItem>
                        <MDBNavItem>
                            <MDBNavLink
                                link
                                to="#"
                                active={this.state.activeItem === "12"}
                                onClick={this.toggleTab("12")}
                                role="tab"
                            >
                                <MDBIcon icon="server" /> Ruckus R1
                            </MDBNavLink>
                        </MDBNavItem>
                    </MDBNav>
                    <MDBTabContent
                        className=""
                        activeItem={this.state.activeItem}
                    >
                        {this.state.operatorInfo !== undefined ? (
                            <>
                                <MDBTabPane tabId="1" role="tabpanel">
                                    <form
                                        className="needs-validation"
                                        onSubmit={this.submitModifyOperator}
                                        noValidate
                                    >
                                        <MDBRow>
                                            <MDBCol size="12" md="12" lg="12">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    Operator Name
                                                </label>
                                                <input
                                                    id="networkOperatorName"
                                                    name="networkOperatorName"
                                                    className="form-control"
                                                    onChange={
                                                        this.changeHandler
                                                    }
                                                    value={
                                                        this.state
                                                            .networkOperatorName
                                                    }
                                                    // disabled={this.state.disabled}
                                                    disabled={true}
                                                />
                                                <div className="invalid-feedback">
                                                    Please provide a valid name.
                                                </div>
                                            </MDBCol>
                                            <MDBCol></MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                            <MDBCol size="12" md="12" lg="6">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    Address 1
                                                </label>
                                                <input
                                                    id="address1"
                                                    name="address1"
                                                    className="form-control"
                                                    onChange={
                                                        this.changeHandler
                                                    }
                                                    value={this.state.address1}
                                                    disabled={
                                                        this.state.disabled
                                                    }
                                                />
                                                <div className="invalid-feedback">
                                                    Please provide a valid
                                                    value.
                                                </div>
                                            </MDBCol>
                                            <MDBCol size="12" md="12" lg="6">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    Address 2
                                                </label>
                                                <input
                                                    id="address2"
                                                    name="address2"
                                                    className="form-control"
                                                    onChange={
                                                        this.changeHandler
                                                    }
                                                    value={this.state.address2}
                                                    disabled={
                                                        this.state.disabled
                                                    }
                                                />
                                                <div className="invalid-feedback">
                                                    Please provide a valid
                                                    value.
                                                </div>
                                            </MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                            <MDBCol size="12" md="12" lg="6">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    City
                                                </label>
                                                <input
                                                    id="city"
                                                    name="city"
                                                    className="form-control"
                                                    onChange={
                                                        this.changeHandler
                                                    }
                                                    value={this.state.city}
                                                    disabled={
                                                        this.state.disabled
                                                    }
                                                />
                                                <div className="invalid-feedback">
                                                    Please provide a valid
                                                    value.
                                                </div>
                                            </MDBCol>
                                            <MDBCol size="12" md="12" lg="6">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    State*
                                                </label>
                                                <div className="select-box">
                                                    <RegionDropdown
                                                        country={
                                                            this.state.country
                                                        }
                                                        value={
                                                            this.state.region
                                                        }
                                                        onChange={(val) =>
                                                            this.selectRegion(
                                                                val
                                                            )
                                                        }
                                                        valueType="short"
                                                        className="form-control"
                                                        id="selectState"
                                                        disabled={
                                                            this.state.disabled
                                                        }
                                                    />
                                                </div>
                                                {this.state.invalidState !==
                                                null ? (
                                                    <div className="invalid">
                                                        {
                                                            this.state
                                                                .invalidState
                                                        }
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                            <MDBCol size="12" md="12" lg="6">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    Postal Code
                                                </label>
                                                <input
                                                    id="postalcode"
                                                    name="postalcode"
                                                    className="form-control"
                                                    onChange={
                                                        this.changeHandler
                                                    }
                                                    value={
                                                        this.state.postalcode
                                                    }
                                                    disabled={
                                                        this.state.disabled
                                                    }
                                                />
                                                <div className="invalid-feedback">
                                                    Please provide a valid
                                                    value.
                                                </div>
                                            </MDBCol>
                                            <MDBCol size="12" md="12" lg="6">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    Country*
                                                </label>
                                                <input
                                                    name="country"
                                                    id="country"
                                                    className="form-control"
                                                    value={this.state.country}
                                                    readOnly
                                                    disabled
                                                />
                                                {this.state.invalidCountry !==
                                                null ? (
                                                    <div className="invalid">
                                                        {
                                                            this.state
                                                                .invalidCountry
                                                        }
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                            <MDBCol size="12" md="12" lg="6">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    Email
                                                </label>
                                                <input
                                                    id="email"
                                                    name="email"
                                                    className="form-control"
                                                    onChange={
                                                        this.changeHandler
                                                    }
                                                    value={this.state.email}
                                                    disabled={
                                                        this.state.disabled
                                                    }
                                                />
                                                <div className="invalid-feedback">
                                                    Please provide a valid
                                                    value.
                                                </div>
                                            </MDBCol>
                                            <MDBCol size="12" md="12" lg="6">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    Phone Number
                                                </label>
                                                <PhoneInput
                                                    placeholder={t(
                                                        "addnewresident.enterphone"
                                                    )}
                                                    value={
                                                        this.state.phoneNumber
                                                    }
                                                    format={FORMAT}
                                                    onChange={
                                                        this.changeHandlerPhone
                                                    }
                                                    name="phoneNumber"
                                                    id="phoneNumber"
                                                    className={
                                                        this.state.loading ===
                                                        true
                                                            ? "form-control loading"
                                                            : "form-control"
                                                    }
                                                    defaultCountry="US"
                                                    required
                                                    error={
                                                        this.state.phoneNumber
                                                            ? isValidPhoneNumber(
                                                                  this.state
                                                                      .phoneNumber
                                                              )
                                                                ? undefined
                                                                : "Invalid phone number"
                                                            : "Phone number required"
                                                    }
                                                    disabled={
                                                        this.state.disabled
                                                    }
                                                />
                                                <div className="invalid-feedback">
                                                    Please provide a valid
                                                    value.
                                                </div>
                                            </MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                            <MDBCol size="12" md="12" lg="6">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    SMS Console Phone Number
                                                </label>
                                                <PhoneInput
                                                    placeholder={t(
                                                        "addnewresident.enterphone"
                                                    )}
                                                    value={
                                                        this.state
                                                            .smsphoneNumber
                                                    }
                                                    format={FORMAT}
                                                    onChange={
                                                        this
                                                            .changeHandlerSMSPhone
                                                    }
                                                    name="smsphoneNumber"
                                                    id="smsphoneNumber"
                                                    className={
                                                        this.state.loading ===
                                                        true
                                                            ? "form-control loading"
                                                            : "form-control"
                                                    }
                                                    defaultCountry="US"
                                                    required
                                                    error={
                                                        this.state
                                                            .smsphoneNumber
                                                            ? isValidPhoneNumber(
                                                                  this.state
                                                                      .smsphoneNumber
                                                              )
                                                                ? undefined
                                                                : "Invalid phone number"
                                                            : "Phone number required"
                                                    }
                                                    disabled={
                                                        this.state.disabled
                                                    }
                                                />
                                                <div className="invalid-feedback">
                                                    Please provide a valid
                                                    value.
                                                </div>
                                            </MDBCol>
                                            <MDBCol size="12" md="12" lg="6">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    Email Domain
                                                </label>
                                                <input
                                                    id="domain"
                                                    name="domain"
                                                    className="form-control"
                                                    onChange={
                                                        this.changeHandler
                                                    }
                                                    value={this.state.domain}
                                                    disabled={
                                                        this.state.disabled
                                                    }
                                                />
                                                <div className="invalid-feedback">
                                                    Please provide a valid
                                                    value.
                                                </div>
                                            </MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                            <MDBCol size="12" md="12" lg="6">
                                                <MDBInput
                                                    label="Allow Overlapping Subscriptions"
                                                    type="checkbox"
                                                    id="allowOverlapping"
                                                    name="allowOverlapping"
                                                    onChange={
                                                        this
                                                            .toggleCheckboxValueAllowOverlapping
                                                    }
                                                    checked={
                                                        this.state
                                                            .allowOverlapping
                                                    }
                                                    disabled={
                                                        this.state.disabled
                                                    }
                                                >
                                                    <MDBTooltip
                                                        material
                                                        placement="left"
                                                        className="rightTooltip"
                                                        style={{
                                                            display: "block",
                                                        }}
                                                    >
                                                        <MDBIcon
                                                            far
                                                            icon="question-circle"
                                                        />
                                                        <span>
                                                            Allow multiple
                                                            subscribers to sign
                                                            up for service in
                                                            the same unit. If
                                                            enabled, a temporary
                                                            unit on a dynamic
                                                            VLAN from the
                                                            Residential Devices
                                                            Range will be
                                                            created while the
                                                            subscription is
                                                            overlapping.
                                                        </span>
                                                    </MDBTooltip>
                                                </MDBInput>
                                                <MDBInput
                                                    label="Allow Custom PSK"
                                                    type="checkbox"
                                                    id="allowCustomPSK"
                                                    name="allowCustomPSK"
                                                    onChange={
                                                        this
                                                            .toggleCheckboxValueAllowCustomPSK
                                                    }
                                                    checked={
                                                        this.state
                                                            .allowCustomPSK
                                                    }
                                                    disabled={
                                                        this.state.disabled
                                                    }
                                                >
                                                    {/* <MDBTooltip
                                                        material
                                                        placement="left"
                                                        className="rightTooltip"
                                                        style={{
                                                            display: "block",
                                                        }}
                                                    >
                                                        <MDBIcon
                                                            far
                                                            icon="question-circle"
                                                        />
                                                        <span>
                                                            Allow multiple
                                                            subscribers to sign
                                                            up for service in
                                                            the same unit. If
                                                            enabled, a temporary
                                                            unit on a dynamic
                                                            VLAN from the
                                                            Residential Devices
                                                            Range will be
                                                            created while the
                                                            subscription is
                                                            overlapping.
                                                        </span>
                                                    </MDBTooltip> */}
                                                </MDBInput>
                                            </MDBCol>
                                            <MDBCol></MDBCol>
                                        </MDBRow>
                                        <br />
                                        <MDBRow>
                                            <MDBCol size="12" md="12" lg="12">
                                                <p>
                                                    <strong>
                                                        Supported Locales
                                                    </strong>
                                                </p>
                                                <OperatorSupportedLocalesTable
                                                    supportedLocalesData={
                                                        this.state.operatorInfo[
                                                            "SupportedLocales"
                                                        ]
                                                    }
                                                />
                                            </MDBCol>
                                        </MDBRow>
                                        <div className="text-right submitButton">
                                            <MDBBtn
                                                color="danger"
                                                type="submit"
                                                disabled={this.state.disabled}
                                            >
                                                {this.state.modify_operator ===
                                                true ? (
                                                    <div
                                                        className="spinner-border spinner-border-sm"
                                                        role="status"
                                                    >
                                                        <span className="sr-only">
                                                            Loading...
                                                        </span>
                                                    </div>
                                                ) : (
                                                    "Save Changes"
                                                )}
                                            </MDBBtn>
                                        </div>
                                    </form>
                                </MDBTabPane>
                                <MDBTabPane tabId="2" role="tabpanel">
                                    {this.state.staffArrayAll !== undefined ? (
                                        <>
                                            <div className="servicePlans">
                                                <OperatorAdministratorsTable
                                                    administratorsData={
                                                        this.state.staffArrayAll
                                                    }
                                                    toggleDisable={
                                                        this
                                                            .toggleConfirmDisable
                                                    }
                                                    resendActivation={this.resendActivation}
                                                    toggleEditDomainAdministrator={this.toggleEditDomainAdministrator}
                                                    refreshAdministratorsTable={this.loadAdministratorsData}
                                                />
                                            </div>
                                            <br />
                                            <br />
                                            <br />
                                            <MDBBtn
                                                color="primary"
                                                className="btn-right"
                                                onClick={
                                                    this.toggleAddDomainAdministrator
                                                }
                                                // disabled={this.state.disabled}
                                            >
                                                Add Administrator
                                            </MDBBtn>
                                        </>
                                    ) : (
                                        <MDBSpinner small />
                                    )}
                                </MDBTabPane>
                                <MDBTabPane tabId="3" role="tabpanel">
                                    <OperatorServicePlansTable
                                        servicePlanData={
                                            this.state.operatorInfo[
                                                "ServicePlans"
                                            ]
                                        }
                                        modifyServicePlan={
                                            this.modifyServicePlan
                                        }
                                        defaultVenueConfig={
                                            this.state.operatorInfo[
                                                "ServicePlanConfiguration"
                                            ]
                                        }
                                        currencySymbol={getSymbolFromCurrency(
                                            this.state.currencySymbol
                                        )}
                                        currencyName={this.state.currencySymbol}
                                    />
                                    <MDBBtn
                                        color="primary"
                                        className="btn-right"
                                        onClick={this.toggleAddServicePlan}
                                        disabled={this.state.disabled}
                                    >
                                        Add Service Plan
                                    </MDBBtn>
                                </MDBTabPane>
                                <MDBTabPane tabId="4" role="tabpanel">
                                    <OperatorRadiusServerTable
                                        radiusServerData={
                                            this.state.operatorInfo[
                                                "NetworkConfiguration"
                                            ]["Radius"]
                                        }
                                        removeRadiusServerConfirm={
                                            this.removeRadiusServerConfirm
                                        }
                                    />
                                    <MDBRow>
                                        <MDBCol col="6">
                                            <p>
                                                <strong>
                                                    Authentication Port
                                                </strong>
                                            </p>
                                            <p>
                                                {
                                                    this.state.operatorInfo[
                                                        "NetworkConfiguration"
                                                    ]["Radius"][
                                                        "AuthenticationPort"
                                                    ]
                                                }
                                            </p>
                                        </MDBCol>
                                        <MDBCol col="6">
                                            <p>
                                                <strong>Accounting Port</strong>
                                            </p>
                                            <p>
                                                {
                                                    this.state.operatorInfo[
                                                        "NetworkConfiguration"
                                                    ]["Radius"][
                                                        "AccountingPort"
                                                    ]
                                                }
                                            </p>
                                        </MDBCol>
                                    </MDBRow>
                                    <br />
                                    <MDBBtn
                                        color="primary"
                                        className="btn-right"
                                        onClick={this.toggleAddRadiusServer}
                                        disabled={this.state.disabled}
                                    >
                                        Add Radius Server
                                    </MDBBtn>
                                </MDBTabPane>
                                {/* <MDBTabPane tabId="5" role="tabpanel">
									<OperatorWiFiControllerTable
										wifiControllerData={
											this.state.operatorInfo["Wi-FiController"][
												"NAS-IP-Address"
											]
										}
										removeWifiControllerConfirm={
											this.removeWifiControllerConfirm
										}
									/>
									<MDBBtn
										color="primary"
										className="btn-right"
										onClick={this.toggleAddWifiController}
									>
										Add Wifi Controller
									</MDBBtn>
								</MDBTabPane> */}
                                <MDBTabPane tabId="6" role="tabpanel">
                                    {this.state.keypoolList !== undefined ? (
                                        <>
                                            <div className="alert mb-3" style={{ backgroundColor: "#e7f3ff", border: "1px solid #b3d9ff", borderRadius: "4px", padding: "12px" }}>
                                                <MDBIcon icon="info-circle" className="mr-2" style={{ color: "#007bff" }} />
                                                Only Global and Venue Keypools are displayed in this list. Unit Level Keypools are available in the Venue Details, Keypool Settings tab, as well as the Unit Details, Keypools settings tab.
                                            </div>
                                            <OperatorKeypoolsTable
                                                operatorKeypoolList={
                                                    this.state.keypoolList
                                                }
                                                getKeypoolInfo={
                                                    this.toggleKeypool
                                                }
                                                modalVieKeypool={
                                                    this.state.modalVieKeypool
                                                }
                                            />
                                            <MDBBtn
                                                color="primary"
                                                className="btn-right"
                                                onClick={this.toggleAddKeypool}
                                                disabled={this.state.disabled}
                                            >
                                                Add Keypool
                                            </MDBBtn>
                                        </>
                                    ) : (
                                        <MDBSpinner small />
                                    )}
                                </MDBTabPane>
                                <MDBTabPane tabId="7" role="tabpanel">
                                    <MDBRow>
                                        <MDBCol col="12">
                                            <p>
                                                <strong>
                                                    Cart Enabled/Disabled
                                                </strong>
                                            </p>
                                            <p className="breakText">
                                                {this.state.shoppingCart[
                                                    "enableShoppingCart"
                                                ] === true
                                                    ? "Enabled"
                                                    : "Disabled"}
                                            </p>
                                        </MDBCol>
                                    </MDBRow>
                                    <br />
                                    <MDBRow>
                                        <MDBCol col="12">
                                            <p>
                                                <strong>
                                                    Issue Refund By Default
                                                </strong>
                                            </p>
                                            <p className="breakText">
                                                {this.state.shoppingCart[
                                                    "Stripe"
                                                ]["Stripe_allowrefund"] === true
                                                    ? "Enabled"
                                                    : "Disabled"}
                                            </p>
                                        </MDBCol>
                                    </MDBRow>
                                    <br />
                                    <MDBRow>
                                        <MDBCol col="12">
                                            <p>
                                                <strong>
                                                    Stripe Publishable Key
                                                </strong>
                                            </p>
                                            <p className="breakText">
                                                {
                                                    this.state.shoppingCart[
                                                        "Stripe"
                                                    ]["StripePublishableKey"]
                                                }
                                            </p>
                                        </MDBCol>
                                    </MDBRow>
                                    <br />
                                    <MDBRow>
                                        <MDBCol col="12">
                                            <p>
                                                <strong>
                                                    Stripe Webhook URL
                                                </strong>
                                            </p>
                                            <p className="breakText">
                                                {
                                                    this.state.shoppingCart[
                                                        "Stripe"
                                                    ]["StripeWebHookURL"]
                                                }
                                            </p>
                                        </MDBCol>
                                    </MDBRow>
                                    <br />
                                    <MDBRow>
                                        <MDBCol col="12">
                                            <p>
                                                <strong>
                                                    Shopping Cart Short URL
                                                </strong>
                                            </p>
                                            <p className="breakText">
                                                {
                                                    this.state
                                                        .shoppingCartShortURL
                                                }
                                            </p>
                                        </MDBCol>
                                    </MDBRow>
                                    <Transactions
                                        currencyName={this.state.currencySymbol}
                                    />
                                    <br />
                                    <MDBBtn
                                        color="primary"
                                        className="btn-right"
                                        onClick={this.toggleAddShoppingCart}
                                        disabled={this.state.disabled}
                                    >
                                        {this.state.shoppingCart["Stripe"][
                                            "StripePublishableKey"
                                        ] !== undefined
                                            ? "Modify Shopping Cart"
                                            : "Add Shopping Cart"}
                                    </MDBBtn>
                                </MDBTabPane>
                                <MDBTabPane tabId="8" role="tabpanel">
                                    <>
                                        <div className="pmsProfiles">
                                            <OperatorPMSProfilesTable
                                                pmsProfilesList={this.state.pmsProfilesList}
                                                loading={this.state.loading_pms_profiles}
                                                modifyPMSProfile={this.modifyPMSProfile}
                                                deletePMSProfile={this.deletePMSProfile}
                                            />
                                        </div>
                                        <br />
                                        <br />
                                        <br />
                                        <MDBBtn
                                            color="primary"
                                            className="btn-right"
                                            onClick={this.toggleAddPMSProfile}
                                            disabled={this.state.disabled}
                                        >
                                            Add PMS Profile
                                        </MDBBtn>
                                    </>
                                </MDBTabPane>
                                <MDBTabPane tabId="9" role="tabpanel">
                                    <MDBRow>
                                        <MDBCol col="12">
                                            <p>
                                                <strong>Webhook URL</strong>
                                            </p>
                                            <p className="breakText">
                                                {this.state.webhookURL}
                                            </p>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBBtn
                                        color="primary"
                                        className="btn-right"
                                        onClick={this.toggleAddWebhook}
                                        disabled={this.state.disabled}
                                    >
                                        {this.state.webhookURL !== undefined
                                            ? "Modify Webhook"
                                            : "Add Webhook"}
                                    </MDBBtn>
                                </MDBTabPane>
                                <MDBTabPane tabId="10" role="tabpanel">
                                    <MDBRow>
                                        <MDBCol col="12">
                                            <LogViewer logType="operator" />
                                        </MDBCol>
                                    </MDBRow>
                                </MDBTabPane>
                                <MDBTabPane tabId="11" role="tabpanel">
                                    <MDBRow>
                                        <MDBCol col="12">
                                            <p>
                                                <strong>
                                                    Single sign-on URL / Reply URL (Assertion Consumer
                                                    Service URL)
                                                </strong>
                                            </p>
                                            <p className="breakText">
                                                {`${this.state.cognitoPoolDomain}/saml2/idpresponse`}
                                                <CopyToClipboardButton textToBeCopied={`${this.state.cognitoPoolDomain}/saml2/idpresponse`} />
                                            </p>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol col="12">
                                            <p>
                                                <strong>
                                                    Audience URL (SP Entity ID)/ Identifier (Entity ID)
                                                </strong>
                                            </p>
                                            <p className="breakText">
                                                {`urn:amazon:cognito:sp:${this.state.cognitoPoolId}`}
                                                <CopyToClipboardButton textToBeCopied={`urn:amazon:cognito:sp:${this.state.cognitoPoolId}`} />
                                            </p>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol col="12">
                                            <p>
                                                <strong>Okta Metadata URL</strong>
                                            </p>
                                            <p className="breakText">{this.state.oktaMetadataURL}</p>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol col="12">
                                            <p>
                                                <strong>Office365 Metadata URL</strong>
                                            </p>
                                            <p className="breakText">
                                                {this.state.office365MetadataURL}
                                            </p>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBBtn
                                        color="primary"
                                        className="btn-right"
                                        onClick={this.toggleAddMetadataURLs}
                                        disabled={this.state.disabled}
                                    >
                                        {(this.state.oktaMetadataURL && this.state.oktaMetadataURL.trim() !== '') ||
                                            (this.state.office365MetadataURL && this.state.office365MetadataURL.trim() !== '')
                                            ? "Modify Metadata URL's"
                                            : "Add Metadata URL's"}
                                    </MDBBtn>
                                    {((this.state.oktaMetadataURL && this.state.oktaMetadataURL.trim() !== '') ||
                                        (this.state.office365MetadataURL && this.state.office365MetadataURL.trim() !== '')) && (
                                            <MDBBtn
                                                color="primary"
                                                className="btn-right"
                                                onClick={this.toggleConfirmDeleteSSO}
                                                disabled={this.state.disabled}
                                            >
                                                Delete Metadata URL's
                                            </MDBBtn>
                                        )}
                                </MDBTabPane>
                                <MDBTabPane tabId="12" role="tabpanel">
                                    <>
                                        <div className="pmsProfiles">
                                            <OperatorRuckusR1Table
                                                ruckusR1Controllers={this.state.ruckusR1Controllers}
                                                loading={this.state.loading_ruckusR1Controllers}
                                                modifyRuckusR1Controller={this.handleModifyRuckusR1}
                                                deleteRuckusR1Controller={this.handleDeleteRuckusR1}
                                                refreshRuckusR1Pools={this.refreshRuckusR1Pools}
                                            />
                                        </div>
                                        <br />
                                        <br />
                                        <br />
                                        <MDBBtn
                                            color="primary"
                                            className="btn-right"
                                            onClick={this.toggleAddRuckusR1}
                                            disabled={this.state.disabled}
                                        >
                                            Add Ruckus R1 Controller
                                        </MDBBtn>
                                    </>
                                </MDBTabPane>
                            </>
                        ) : (
                            ""
                        )}
                    </MDBTabContent>
                </MDBModalBody>
                <MDBModalFooter>
                    <MDBBtn
                        color="primary"
                        onClick={this.props.toggleOperatorInfo}
                    >
                        Ok
                    </MDBBtn>
                </MDBModalFooter>
                <MDBModal
                    isOpen={this.state.showEditModal}
                    toggle={() => this.toggleEditDomainAdministrator()}
                    size="lg"
                >
                    <EditDomainAdministrator
                        administrator={this.state.selectedAdministrator}
                        toggleEditDomainAdministrator={this.toggleEditDomainAdministrator}
                        onRoleUpdated={this.handleRoleUpdated}
                        refreshAdministratorsTable={this.loadAdministratorsData}
                    />
                </MDBModal>

                {/* PMS Profile Delete Confirmation Modal */}
                {this.state.toggleConfirmDeletePMSProfile && (
                    <MDBModal 
                        isOpen={this.state.toggleConfirmDeletePMSProfile} 
                        toggle={this.toggleConfirmDeletePMSProfile}
                        centered
                    >
                        <MDBModalHeader toggle={this.toggleConfirmDeletePMSProfile}>
                            Confirm Delete PMS Profile
                        </MDBModalHeader>
                        <MDBModalBody>
                            <p>Are you sure you want to delete the PMS Profile:</p>
                            <p><strong>{this.state.selectedPMSProfileForDeletion?.ProfileName}</strong></p>
                            <p>This action cannot be undone.</p>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn
                                color="danger"
                                onClick={this.confirmDeletePMSProfile}
                                disabled={this.state.delete_pms_profile}
                            >
                                {this.state.delete_pms_profile ? (
                                    <>
                                        <div
                                            className="spinner-border spinner-border-sm mr-2"
                                            role="status"
                                        >
                                            <span className="sr-only">
                                                Loading...
                                            </span>
                                        </div>
                                        Deleting...
                                    </>
                                ) : (
                                    "Delete Profile"
                                )}
                            </MDBBtn>
                            <MDBBtn 
                                color="danger"
                                onClick={this.toggleConfirmDeletePMSProfile}
                                disabled={this.state.delete_pms_profile}
                            >
                                Cancel
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>
                )}
                <MDBModal
                    isOpen={this.state.modalAddRuckusR1}
                    toggle={this.toggleAddRuckusR1}
                    size="lg"
                    className="form"
                    centered
                >
                    <AddRuckusR1
                        toggleAddRuckusR1={this.toggleAddRuckusR1}
                        submitAddRuckusR1={this.submitAddRuckusR1}
                        loading_ruckus={this.state.loading_ruckus}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalModifyRuckusR1}
                    toggle={this.toggleModifyRuckusR1}
                    size="lg"
                    className="form"
                    centered
                >
                    <ModifyRuckusR1
                        controller={this.state.selectedRuckusR1Controller}
                        toggleModifyRuckusR1={this.toggleModifyRuckusR1}
                        submitModifyRuckusR1={this.submitModifyRuckusR1}
                        loading_ruckus={this.state.loading_ruckus}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalDeleteRuckusR1}
                    toggle={this.toggleDeleteRuckusR1}
                    size="md"
                    centered
                >
                    <MDBModalHeader toggle={this.toggleDeleteRuckusR1}>
                        Confirm Delete Ruckus R1 Controller
                    </MDBModalHeader>
                    <MDBModalBody>
                        <p>Are you sure you want to delete the Ruckus R1 Controller:</p>
                        <p><strong>{this.state.controllerToDelete?.ControllerName}</strong></p>
                        <p>This action cannot be undone.</p>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn 
                            color="danger" 
                            onClick={this.confirmDeleteRuckusR1}
                            disabled={this.state.loading_ruckus}
                        >
                            {this.state.loading_ruckus ? (
                                <div
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                "DELETE CONTROLLER"
                            )}
                        </MDBBtn>
                        <MDBBtn 
                            color="primary" 
                            onClick={this.toggleDeleteRuckusR1}
                            disabled={this.state.loading_ruckus}
                        >
                            CANCEL
                        </MDBBtn>
                    </MDBModalFooter>
                </MDBModal>
            </>
        );
    }
}
export default withTranslation()(OperatorInfo);
